import api from '../../../api';
import { UpdateSafetySettingsRequestPayload } from '../types/request-payload';

export const updateSafetySettings = async (
  payload: UpdateSafetySettingsRequestPayload,
) => api.patch(`/safety-settings`, payload);

export const getSafetySettings = async () => api.get(`/safety-settings`);
